import agendaApiConfig from "./agendaApiConfig";

const ExamenService = {

    async getExamenes(codeExamen = 0) {

        console.log("codeExamen => ", codeExamen);

        let query =  {}; 
        console.log("getExamenes => ", process.env.REACT_APP_SERVICIO_IMG);
        if(process.env.REACT_APP_SERVICIO_IMG == ""){
            query = null;
        }else{
            query =  {ser_codigo : process.env.REACT_APP_SERVICIO_IMG }; 
        }

        return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`, {
            params: {
                ...query
            }
        });

        //return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`);
    }
}

export default ExamenService;